import ES6Modal from "./es6.modal";

/**
 * Injects iframe with Cookies Policy Consent
 */
export default class CookiesPolicyHandler {

	ES6Modal;

	async init() {
		const em_target_component_selector = '#easymarkets-tpw';
		const target = document.querySelector(`#cookiesPolicyModal ${em_target_component_selector}`)

		this.#setAttributes(target);

		const { default: injectScript } = await import(/* webpackChunkName: "./project.links" */'./inject.script');
		const { default: ProjectLinks } = await import(/* webpackChunkName: "./inject.script" */'./project.links');

		const connectUrl = ProjectLinks.getProjectLink('connect');
		injectScript(`${connectUrl}/webroot/easymarkets-tpw.js`);

		// TODO: create dedicated function to handle messages, keep here only related to implementation logic
		window.addEventListener('message', function (event) {

			if (!event.data) return;

			// try to parse string data into JSON
			let data;
			try {
				if (typeof event.data !== 'object') {
					data = JSON.parse(event.data);
				}
			} catch (error) {
				console.error('%cFailed to receive data from iframe: %c' + error, 'font-weight: bold; text-decoration: underline;', 'font-weight: normal;');
				console.error('%cReceived: %c' + event.data, 'font-weight: bold; text-decoration: underline;', 'font-weight: normal;');
			}

			// type 1: messages for parentWindow
			if (!data || data.type !== 1) return;

			// Include in reveived message name to filter out not related target window messages
			if (data.name && data.name.includes('easymarkets_widget_message')) {
				switch (data.name) {
					case 'easymarkets_widget_message_cookies_openModal':
						if (this.ES6Modal) {
							console.warn('Modal already opened, skipping');
							break;
						}
						this.ES6Modal = new ES6Modal({
							modalId: 'cookiesPolicyModal',
							size: 'large',
							removeModalScrollingForMobile: true
						});
						this.ES6Modal.open();
						break;

					case 'easymarkets_widget_message_cookies_closeModal':
						this.ES6Modal.close();
						break;

					case 'easymarkets_widget_message_cookies_acceptedBefore':
						// not aplicatable for lnd
						break;

					default:
						console.warn('Received message have undefined or unknown name, skipping');
						break;
				}
			}
		})
	}

	#setAttributes = (target) => {

		const langAttr = document.createAttribute('language');
		langAttr.value = easymarkets.data.language;
		target.attributes.setNamedItem(langAttr);

		const cultureAttr = document.createAttribute('culture');
		cultureAttr.value = easymarkets.data.culture;
		target.attributes.setNamedItem(cultureAttr);
	}
}
